import {
  BIOME_ABOUT,
  PUBLICATIONS_BIOME,
  STORIES_BIOME,
} from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './BiomeAbout'

export default withLocalization(Component, BIOME_ABOUT, {
  publications: PUBLICATIONS_BIOME,
  stories: STORIES_BIOME,
})
